import { useEffect, useState } from 'react';
import Animate from 'src/components/animate';
import i18n from 'src/utils/translate';
import { throttle } from 'lodash';

export default function BackToTop() {

  const [showScroll, setShowScroll] = useState(false);

  const onScroll = throttle(() => setShowScroll(window.scrollY > 0), 300);

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [onScroll]);

  return (
    <Animate show={showScroll} transitionType="TRANSITION-simpleFade">
      <button
        className={'back-to-top back-to-top--navbar icon-up-open'}
        title={i18n.t('Back to top')}
        type="button"
        onClick={() => window.scrollTo(0, 0)}
      />
    </Animate>
  );
}
